import React, { useEffect, useState } from 'react'
import HTMLParser from '../../General/NotesTab/ParserHtml';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import DeleteConfirmatiom from '../../General/DeleteConfirmation';
import isNull from '../../../utils/NullChecking';
import SuperSearchList from '../SuperSearch/SuperSearchList';
import Loader from '../Loader/Loader';

const Alert = ({ ID, type, AddAlertcode, refresh, PaymentType, handleSaveAlertType, LoadData, activeTab }) => {
    const StatusDD = [
        { value: '-1', display: '' },
        { value: 'Active', display: 'Show Active' },
        { value: 'InActive', display: 'Show InActive' },
    ]

    const [status, setStatus] = useState('Active');
    const [statusDisplay, setStatusDisplay] = useState('Show Active');

    const [alertData, setAlertData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const API_URL_General = enumUtil.controller.General
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [id, setID] = useState(null)

    const loadAlertData = (searchparam) => {
        setAlertData([]);
        setIsLoading(true);
        let searchCriteria = {}
        if (type === 'Claim') {
            searchCriteria['ClaimID'] = ID;
        }
        if (type === 'Patient') {
            searchCriteria['PatientID'] = ID;
        }
        if (type === 'Payment') {
            searchCriteria['PaymentID'] = ID;
            searchCriteria['PaymentType'] = PaymentType;

        }
        let saveModal = {
            "TableName": enumUtil.enumAPITableName.Alert,
            "SearchCriteria": { ...searchCriteria },
            "SearchParam": searchparam,
            "PerPage": '10',
            "PageNo": '1',
        }
        if (activeTab === 'alert') {
            ServerRequestProtected(API_URL_General + '/FindByMultipleCriteria', 'post', saveModal)
                .then((response) => {
                    setIsLoading(false);
                    setAlertData(response.Rows);
                }).catch((error) => {
                    setIsLoading(false);
                })
        }
    }
    const handleSetDefault = () => {
        loadAlertData(status);
    }
    const handleDeleteModal = (ID) => {
        setID(ID)
        setIsOpenDelete(true)
    }
    const onCloseDeleteAlert = () => {
        setIsOpenDelete(false)
    }
    let DeleteConfirmationAlert = "";
    if (isOpenDelete) {
        DeleteConfirmationAlert = <DeleteConfirmatiom isOpenAlert={isOpenDelete} onCloseDelete={onCloseDeleteAlert} API_URL={API_URL_General} TableName={enumUtil.enumAPITableName.Alert} ID={id} onClose={handleSetDefault} />
    }
    useEffect(() => {
        if (!isNull(refresh)) {
            loadAlertData(status)
        }
    }, [refresh])
    useEffect(() => {
        loadAlertData(status)
    }, [status, LoadData])


    const handleSelectedData = (selectedData, name, type) => {
        if (type === 'server' && !isNull(selectedData)) {

        }
        else if (type === 'client' && !isNull(selectedData)) {
            setStatus(selectedData.value);
            setStatusDisplay(selectedData.display);
        }
        else {
            setStatusDisplay('');
            setStatus('');

        }
    }
    const handleChange = (e) => {
        let { name, value } = e.target
        setStatusDisplay(value);

    }
    const handleIsActiveChange = (checked, alertID) => {
        // console.log(recordID,'recordID');

        setAlertData(prev =>
            prev.map(item => {
                console.log(item, 'RecordID', alertID);
                return item.RecordID === alertID
                    ? { ...item, IsActive: checked ? "True" : "False" }
                    : item;
            })
        );
        handleSaveAlertType(alertID, checked);
    };
    return (
        <div>
            {DeleteConfirmationAlert}
            {isLoading ? <Loader /> : null}
            <div className="d-flex align-items-center justify-content-between px-10 mb-2">
                <p className='heading'>Alerts</p>
                <div className="input w-112px">
                    <SuperSearchList
                        type="client"
                        id='Status'
                        name='Status'
                        searchValue={statusDisplay}
                        data={StatusDD}
                        onChange={(e) => handleChange(e)}
                        getSelectedData={handleSelectedData}
                        icon={'Simple'}
                        sup_btn='sup_btn'
                        sup_inp='superSearchVisitInp'
                    />
                </div>
            </div>
            <div className="patient_notes_content d-flex flex-column gap-18 alerts-scroll hover-scrollbar">
                {alertData.length > 0 &&
                    alertData.map((item, index) => (
                        console.log('recordIDD', item),

                        <div className="notes-content px-10 py-0 mh-100 h-100 overflow-visible">
                            <div className="notes-content__alerts p-2">
                                <React.Fragment >
                                    <div className="notes-content__alerts__body">
                                        <HTMLParser htmlContent={item.Contains} />
                                        <div className='d-flex align-items-center justify-content-between my-2'>
                                            <div className='d-flex gap-1 align-items-center m-0'>
                                                <p className='fs-11 text font-m lh-11'>Active</p>
                                                <div class="pe-0 m-0 insurance_radio_btn">
                                                    <div class="form-check form-switch radio_button mh-unset m-0">
                                                        <input
                                                            class="form-check-input m-0"
                                                            type="checkbox"
                                                            id="mySwitch"
                                                            name="IsActive"
                                                            // checked={item?.IsActive}
                                                            checked={item.IsActive === "True"}
                                                            onChange={e => handleIsActiveChange(e.target.checked, item.RecordID)}

                                                        // defaultChecked onClick={() => handleIsActiveChange(item.RecordID)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex align-items-center gap-1 m-0'>
                                                <i className="icon-edit-pencil fs-12" onClick={() => AddAlertcode(item.RecordID)} />
                                                <i className="icon-delete fs-12 text-danger" onClick={() => handleDeleteModal(item.RecordID)} />
                                            </div>
                                        </div>
                                        <p className='text fs-11 font-m ar-light-color pb-1'>Expire on: <span className='font-r ps-1-5'>{item?.EndDate}</span></p>

                                        <div className="br-top-1 pt-2 za_br_light m-0">
                                            <p className='text fs-11 font-m ar-light-color'>By, Date: <span className='font-r ps-1-5'>{item.UpdatedBy} {item.UpdatedDate}</span></p>
                                        </div>
                                    </div>
                                    {/* <div className="notes-content__alerts__footer">
                                        <p><b>By:</b> {item.UpdatedBy}</p>
                                        <p><b>Date:</b> {item.UpdatedDate}</p>
                                    </div> */}
                                </React.Fragment>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Alert
